module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      blueBg: _vm.$route.meta.isBlueBg,
      transHeader: _vm.hasTransHeader,
      isAuthView: _vm.$route.meta.isAuthView,
      isLoggedOut: !_vm.$route.meta.isAuthView && !_vm.$store.state.user.scope
    },
    attrs: {
      "id": "app"
    }
  }, [_c('boot-loader', {
    attrs: {
      "loadingMessage": _vm.loadingMessage
    }
  }), _vm._v(" "), (_vm.loggedIn) ? _c('mu-drawer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$route.meta.isAuthView),
      expression: "!$route.meta.isAuthView"
    }],
    staticClass: "app-drawer",
    class: {
      isMobile: !_vm.docked
    },
    attrs: {
      "open": _vm.isOpen,
      "docked": _vm.docked
    },
    on: {
      "close": function($event) {
        return _vm.toggle(false)
      }
    }
  }, [_c('mu-content-block', {
    staticClass: "nav-head"
  }, [(_vm.$store.state.user.scope.profile_thumb !== null) ? _c('mu-avatar', {
    attrs: {
      "size": 28,
      "src": _vm.$store.state.user.scope.profile_thumb,
      "color": "white",
      "backgroundColor": "grey"
    },
    on: {
      "click": _vm.goToProfile
    }
  }) : _c('mu-avatar', {
    staticClass: "blue",
    attrs: {
      "size": 28,
      "color": "white",
      "backgroundColor": "grey"
    },
    on: {
      "click": _vm.goToProfile
    }
  }, [_vm._v("\n          " + _vm._s(_vm.upperTwoInitials) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.$store.state.user.scope.display_name && _vm.$store.state.user.scope.use_display_name ? _vm.$store.state.user.scope.display_name : _vm.$store.state.user.scope.firstname)
    }
  }), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-icon-menu', {
    attrs: {
      "icon": "settings",
      "open": _vm.menuOpen,
      "desktop": "",
      "menuListClass": "hasAvatar dashboard-menu"
    }
  }, [_c('user-avatar', {
    staticStyle: {
      "width": "100%",
      "margin-top": "-16px",
      "margin-bottom": "-8px"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile()
      }
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.dashboardAppBarText'),
      "leftIcon": "dashboard"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/dashboard')
      }
    }
  }), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.discussionTabMyQuestions'),
      "leftIcon": "chat"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/questions?type=MY_QUESTIONS')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelMyProfile'),
      "leftIcon": "person"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/profile/' + _vm.$store.state.user.profile.profile_url)
      }
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.settingsMenuTitleText'),
      "leftIcon": "settings_cog"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/settings')
      }
    }
  }), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-divider') : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-menu-item', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: (_vm.$t('message.labelAddHealthSnapshot')),
      expression: "$t('message.labelAddHealthSnapshot')",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "leftIcon": "add",
      "title": _vm.$t('message.addProgressAppBarText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('/add-progress')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-menu-item', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: (_vm.$t('message.labelAddFoods')),
      expression: "$t('message.labelAddFoods')",
      modifiers: {
        "left": true
      }
    }],
    attrs: {
      "leftIcon": "add",
      "title": _vm.$t('message.foodDiaryAddFoodAppBarText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('/food-diary/')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-divider') : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.addTestimonialText'),
      "disabled": _vm.showTestimonial,
      "leftIcon": "edit"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/testimonials')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.labelHelp'),
      "leftIcon": "live_help"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToContact.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.$t('message.logOutText'),
      "leftIcon": "exit_to_app"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logOut.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-list', {
    staticStyle: {
      "margin-top": "0px !important"
    },
    attrs: {
      "id": "nav"
    },
    on: {
      "itemClick": function($event) {
        _vm.docked ? '' : _vm.toggle(false)
      }
    }
  }, [_c('mu-list-item', {
    attrs: {
      "to": "/dashboard",
      "title": _vm.$t('message.dashboardMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": _vm.isHcpView && _vm.isHcpUser ? 'home' : 'dashboard'
    },
    slot: "left"
  })], 1), _vm._v(" "), (_vm.isHcpView) ? _c('mu-list-item', {
    attrs: {
      "to": "/hcp",
      "title": 'Education'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "school"
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "to": _vm.isHcpView && _vm.isHcpUser ? '/life/category/evidence-and-papers' : '/life',
      "title": _vm.isHcpView && _vm.isHcpUser ? 'Evidence and Papers' : _vm.$t('message.lifestyleMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "local_florist"
    },
    slot: "left"
  })], 1), _vm._v(" "), (_vm.isHcpUser && _vm.isHcpView) ? _c('mu-list-item', {
    attrs: {
      "to": "/downloads",
      "title": "Resources"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "file_downloads"
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "to": !_vm.isHcpVerified && _vm.isHcpView ? '' : '/questions',
      "disabled": !_vm.isHcpVerified && _vm.isHcpView,
      "title": _vm.isHcpView && _vm.isHcpUser ? 'Forum' : _vm.$t('message.questionsMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": _vm.isHcpView || _vm.isHcpUser ? 'textsms' : 'live_help'
    },
    slot: "left"
  })], 1), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-list-item', {
    attrs: {
      "to": "/food-diary",
      "title": _vm.$t('message.foodDiaryMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "book"
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-list-item', {
    staticClass: "recipe-menu",
    attrs: {
      "title": _vm.$t('message.recipeMenuTitleText'),
      "toggleNested": "",
      "open": false
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "restaurant"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "slot": "nested",
      "title": "All Recipes",
      "to": "/recipes/",
      "exact": true
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    },
    slot: "nested"
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "view_carousel"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "slot": "nested",
      "disableRipple": "",
      "title": "Favourites",
      "to": "/recipes/favorites/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    },
    slot: "nested"
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "grade"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "slot": "nested",
      "disableRipple": "",
      "title": "Search",
      "to": "/recipes/search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    },
    slot: "nested"
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "search"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "slot": "nested",
      "disableRipple": "",
      "title": "Meal Plan Generator",
      "to": "/recipes/generator/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    },
    slot: "nested"
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "refresh"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "slot": "nested",
      "disableRipple": "",
      "title": "My Meal Plans",
      "to": "/recipes/mealplans/"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    },
    slot: "nested"
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "view_list"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-list-item', {
    staticClass: "shop-menu",
    attrs: {
      "title": _vm.$t('message.shopMenuTitleText'),
      "toggleNested": "",
      "open": false
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "shopping_cart"
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "slot": "nested",
      "disableRipple": "",
      "title": "Books",
      "target": "_blank",
      "href": "https://shop.lowcarbprogram.com/collections/books"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    },
    slot: "nested"
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "book"
    },
    slot: "left"
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-list-item', {
    attrs: {
      "to": "/add-progress",
      "title": _vm.$t('message.addProgressMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "add_plus"
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isHcpView && _vm.$store.state.user.scope.country.country_id === 41) ? _c('mu-list-item', {
    attrs: {
      "to": "/coaching",
      "title": _vm.$t('message.coachingMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "school"
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isHcpUser || !_vm.isHcpView) ? _c('mu-list-item', {
    attrs: {
      "to": "/downloads",
      "title": _vm.$t('message.downloadsMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "file_downloads"
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "to": "/coaching",
      "title": "Coaching"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "sports"
    },
    slot: "left"
  })], 1), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-list-item', {
    attrs: {
      "to": '/profile/' + _vm.$store.state.user.profile.profile_url,
      "title": _vm.$t('message.profileMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "person"
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "to": "/contact",
      "title": _vm.$t('message.feedbackMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "feedback"
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('mu-list-item', {
    attrs: {
      "to": "/settings",
      "title": _vm.$t('message.settingsMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "settings"
    },
    slot: "left"
  })], 1), _vm._v(" "), (!_vm.isHcpView) ? _c('mu-list-item', {
    attrs: {
      "to": "/faq",
      "title": _vm.$t('message.faqMenuTitleText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeIfMobile.apply(null, arguments)
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "help"
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isHcpView || _vm.isHcpUser) ? _c('mu-list-item', {
    staticClass: "hcpSwitch",
    attrs: {
      "disabled": !_vm.isHcpVerified && _vm.isHcpView,
      "title": _vm.isHcpView ? _vm.$t('message.labelSwitchPatient') : _vm.$t('message.labelSwitchHcp')
    },
    on: {
      "click": function($event) {
        _vm.toggleHcpSwitchModal = true
      }
    }
  }, [_c('mu-icon', {
    staticClass: "left8",
    attrs: {
      "slot": "left",
      "value": "swap_horizontal_circle"
    },
    slot: "left"
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.status.payment.paid === false) ? _c('payment-call-to-action') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "page-content",
    class: {
      sidebarOpen: _vm.isOpen,
      isMobile: !_vm.docked
    }
  }, [((_vm.$route.meta.isAuthView && !_vm.$route.meta.hideRegisterAppBar)) ? _c('mu-appbar', {
    class: {
      appBarClosed: !_vm.isOpen,
      noShadow: _vm.$route.meta.hideShadow
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.applicationContext === 'grohealth') ? _c('img', {
    staticClass: "logo",
    attrs: {
      "width": "26",
      "src": require("assets/gro-small.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.applicationContext === 'lowcarbprogram') ? _c('img', {
    staticClass: "logo",
    attrs: {
      "width": "200",
      "src": "static/logos/lcp-logo.svg"
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showLogOut) ? _c('div', {
    staticClass: "logout-button",
    on: {
      "click": _vm.logOut
    }
  }, [_c('span', [_c('mu-icon', {
    attrs: {
      "value": "exit_to_app"
    }
  }), _vm._v("\n              Log out\n            ")], 1)]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.isAuthView && _vm.$store.state.user.scope) ? _c('mu-appbar', {
    class: {
      appBarClosed: !_vm.isOpen,
      transparent: _vm.$route.meta.isBlueBg
    },
    attrs: {
      "title": _vm.replaceTitle ? _vm.replaceTitle : _vm.$route.meta.title + (_vm.$route.meta.hasCustomTitle ? ': ' + _vm.externalTitle : '')
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "left",
      "iconClass": "menu-icon material-icons-round",
      "icon": "menu"
    },
    on: {
      "click": function($event) {
        return _vm.toggle(false)
      }
    },
    slot: "left"
  }), _vm._v(" "), (_vm.$route.meta.isChild) ? _c('mu-icon-button', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "left",
      "icon": "chevron_left"
    },
    on: {
      "click": function($event) {
        return _vm.goBack(_vm.$route)
      }
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), ((_vm.isHcpView || _vm.isHcpUser) && _vm.isHcpVerified) ? _c('mu-icon', {
    staticClass: "mobileHcpSwitch",
    attrs: {
      "slot": "right",
      "value": "swap_horizontal_circle",
      "color": "#FFF"
    },
    on: {
      "click": function($event) {
        _vm.toggleHcpSwitchModal = true
      }
    },
    slot: "right"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-right": "20px",
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('span', {
    staticClass: "user-block pointer",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        return _vm.goToProfile()
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.$store.state.user.scope.use_display_name ? _vm.$store.state.user.scope.display_name : _vm.$store.state.user.scope.firstname))]), _vm._v(" "), (_vm.$store.state.user.scope.profile_thumb !== null) ? _c('mu-avatar', {
    staticStyle: {
      "margin-left": "12px",
      "border": "2px solid #fff"
    },
    attrs: {
      "size": 32,
      "src": _vm.$store.state.user.scope.profile_thumb,
      "color": "white",
      "backgroundColor": "grey"
    },
    on: {
      "click": _vm.goToProfile
    }
  }) : _c('mu-avatar', {
    staticClass: "blue",
    staticStyle: {
      "margin-left": "12px",
      "border": "2px solid #fff"
    },
    attrs: {
      "size": 32,
      "color": "white",
      "backgroundColor": "grey"
    },
    on: {
      "click": _vm.goToProfile
    }
  }, [_vm._v("\n            " + _vm._s(_vm.upperTwoInitials) + "\n          ")])], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('notifications-panel', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "right",
      "visible": _vm.isNotificationsPanelVisible
    },
    on: {
      "panelHidden": _vm.hidePanelFn
    },
    slot: "right"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.isAuthView && !_vm.$store.state.user.scope) ? _c('mu-appbar', {
    class: {
      appBarClosed: !_vm.isOpen
    },
    attrs: {
      "title": _vm.$route.meta.title + (_vm.$route.meta.hasCustomTitle ? ': ' + _vm.externalTitle : '')
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-content-block', {
    staticClass: "main-content",
    attrs: {
      "id": _vm.$route.meta.id
    },
    nativeOn: {
      "scroll": function($event) {
        return _vm.handleScroll.apply(null, arguments)
      }
    }
  }, [(_vm.isHcpView && _vm.isHcpUser) ? _c('hcp-search') : _vm._e(), _vm._v(" "), (_vm.$store.state.list.diabetes_types) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "siteFooter content",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50",
      "align": "center"
    }
  }, [_c('div', [_vm._v("\n\n                " + _vm._s(_vm.$t('message.labelMadeWith')) + "\n\n                "), _c('mu-icon', {
    attrs: {
      "color": "#D83E38",
      "size": 12,
      "value": "favorite"
    }
  }), _vm._v(" "), (_vm.applicationContext === 'grohealth') ? _c('span', [_vm._v("grohealth.com")]) : _vm._e(), _vm._v(" "), (_vm.applicationContext === 'lowcarbprogram') ? _c('span', [_vm._v("lowcarbprogram.com")]) : _vm._e(), _vm._v(" © " + _vm._s(_vm.currentYear) + "\n              ")], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "25",
      "tablet": "25",
      "desktop": "25"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.$route.meta.paymentWall && _vm.$store.state.status.payment.paid === false) ? _c('paywall', {
    attrs: {
      "show": _vm.showPaywall
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHcpUser) ? _c('hcp-switch-modal', {
    attrs: {
      "open": _vm.toggleHcpSwitchModal
    },
    on: {
      "close": function($event) {
        return _vm.closeHcpSwitchModal()
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 3281
// module chunks = 1